import { render, staticRenderFns } from "./download.vue?vue&type=template&id=1e41e22c"
import script from "./download.js?vue&type=script&lang=js&external"
export * from "./download.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports